import styles from "./myfavorite.module.scss";
import { CommonSelect, CstmPagination } from 'components/Common/Common';
import ErrorComponent from 'components/shared/ErrorComponent';
import TableHeader from 'components/shared/FormComponents/TableHeader';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayoutV2 from 'components/TableLayoutV2';
import { CLASSROOM_STATUS_OPTIONS, classroomReportStatusOptions, GRADE_OPTIONS, reportDateFormat } from 'config/constants';
import { dateFormat, userFullName } from 'helpers/common';
import { cloneDeep, debounce } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Dropdown, Row } from 'react-bootstrap'
import { Star } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { useClassroomConsultationsArchiveMutation, useClassroomConsultationsFavUnfavMutation, useClassroomConsultationsListQuery } from 'store/services/clients/classroomConsultation';
import { useDisciplineLookupQuery } from "store/services/disciplines";
import { useGetSchoolDivisonListForFilterQuery } from "store/services/schoolsDivisons";
import { useLazyGetFileUrlQuery, useTeacherLookupQuery } from 'store/services/utility';
import rightArrow from "../../../../Assets/images/rightArro.png"
import downArrow from "../../../../Assets/images/downArro.png"
import { DownArrowIcon } from "Assets/icons/V2";
import confirmDialogV2 from "utils/confirmationDialogV2";

const ClassroomConsultations = () => {
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
  const [openRow, setOpenRow] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({ search: "", status: {value: "complete", label: "Complete"}, assign_term: "", school_division: "", school: "", grade: "", assign_term: "", sort: { column: "id", direction: "desc" } });
  const [currentPage, setCurrentPage] = useState(1);
  const [consultationList, setConsultationList] = useState([]);
  const [schoolOptionList, setSchoolOptionList] = useState([]);
  // const [getSchools, { isFetching: schoolsLoading }] = useGetSchoolClientsListQuery()
  const { data: schoolDivisonsList, isLoading: schoolsLoading } = useGetSchoolDivisonListForFilterQuery({});
  const [schoolOptions, setSchoolOptions] = useState([]);
  const { data: classroomConsultationList, isLoading: classroomConsultationListLoading, isFetching: classroomConsultationListFetching, isError: classroomConsultationListError } = useClassroomConsultationsListQuery({ page: currentPage, limit: pageSize, ...filter })
  const [favouriteReport, { isLoading: favouriteReportLoading }] = useClassroomConsultationsFavUnfavMutation()
  const totalRecords = classroomConsultationList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const { data: disciplinesList } = useDisciplineLookupQuery({});
  const { data: teachers, isFetching: teachersListFetching } = useTeacherLookupQuery({});
  const [teachersList, setTeachersList] = useState([]);
  const [archiveReport, { isLoading: archiveReportLoading }] = useClassroomConsultationsArchiveMutation();

  const handleArchiveReport = async (e, reportId, status) => {
    e.stopPropagation();
    console.log('reportId, status', reportId, status)
    const isConfirm = await confirmDialogV2({
      title: `${status.toUpperCase()} REPORT ?`,
      message: `Are you sure you want to ${status == 'complete' ? "complete " : "archive " }this report?`,
    });
    if (!isConfirm) {
      return;
    }
    try {
      await archiveReport({ id: reportId, status }).unwrap()
    } catch (error) {
      clog('error', error)
    }
  }


  useEffect(() => {
    if (schoolDivisonsList && !filter?.school_division) {
      setSchoolOptions(schoolDivisonsList?.reduce((acc, value) => ([...acc, ...value.schools]), [])?.sort((a, b) => a?.name?.localeCompare(b?.name)))
    };

    if (filter?.school_division) {
      const division = cloneDeep(schoolDivisonsList?.find(x => x.id == filter?.school_division?.value));
      setSchoolOptions(division?.schools?.sort((a, b) => a?.name?.localeCompare(b?.name)))

    }
  }, [schoolDivisonsList, filter.school_division]);

  useEffect(() => {
    if (teachers) {
      const data = teachers?.map((item) => ({ label: userFullName(item), value: item?.id }))
      setTeachersList(data)
    }
  }, [teachers]);

  console.log('teachers', teachers)

  const getSchoolOptions = async (search) => {
    try {
      const result = await getSchools(search);
      if (result?.data?.[0]?.id) {
        const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
        setSchoolOptionList(data);
      }
    } catch (error) { console.log("Error Getting school options"); };

  };

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const handleDelete = async () => {
    try {

      setShowModal(false);
      const list = cloneDeep(consultationList);
      const index = list.findIndex(x => x.id == currentEntry?.id);
      if (index > -1) delete list[index];
      setConsultationList(list?.filter(Boolean));

      const result = await deleteConsultation(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting classroom consultation", err);
    };
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFavouriteReport = async (report_id, favourite) => {
    try {
      await favouriteReport({ id: report_id, data: { favorite: favourite } }).unwrap()
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleViewPdf = async (name) => {

    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };


  const columns = [
    {
      head: <div onClick={() => setFilter((prev) => ({ ...prev, sort: prev?.sort?.column == "is_favorite" ? { column: "id", direction: "desc" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1) }}>{item?.is_favorite ? <Star fill="#315D99" stroke="#315D99" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: "Date",
      accessor: "screening_date",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">{dateFormat(item?.screening_date, reportDateFormat) || "--"}</h6>
      ),
    },
    {
      head: "Discipline",
      accessor: "reportsPreflightOwner",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div>
          {
            <span className={`discipline-${item?.reportsPreflightOwner?.therapist_detail?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.reportsPreflightOwner?.therapist_detail?.therapist_discipline?.assign_term}</span>
          }
        </div>
      ),
    },
    {
      head: "School",
      accessor: "school",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize">{item?.reportsPreflightSchool?.name || "--"}</div>
      ),
    },
    {
      head: "Teacher",
      accessor: "teacher",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize fw-bold">{userFullName(item?.reportsPreflightTeacher) || "--"}</div>
      ),
    },
    // {
    //   head: "Age",
    //   accessor: "report_age_range",
    //   isComponent: true,
    //   sorter: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 ">{item?.report_age_range || "--"}</h6>
    //   ),
    // },
    {
      head: "Grade",
      accessor: "report_grade",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 ">{item?.report_grade || "--"}</h6>
      ),
    },
    {
      head: "Class",
      accessor: "report_classname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize fw-bold">{item?.report_classname || "--"}</div>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <>
          <div>
            <Dropdown
              onClick={(e) => e.stopPropagation()}
            >
              <Dropdown.Toggle
                variant="transparent"
                className="p-0 border-0 text-dark w-100 d-flex align-items-center gap-0"
                id="dropdown-basic"
              >
                <p
                  style={{ width: 80, fontStyle: item?.status != "active" && "italic" }}
                  className={`${item.status == "active"
                    && "greenStatus"
                    // : "redStatus"
                    } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-2 py-1`}
                >
                  {item.status}
                </p>
                <DownArrowIcon />

              </Dropdown.Toggle>

              <Dropdown.Menu className="" style={{ right: 0, left: "unset", minWidth: "150px" }}>
                <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                  {CLASSROOM_STATUS_OPTIONS
                    .filter((status) =>
                      // {
                      status.value != item.status
                      //   const currentStatus = item?.status;
                      //   if (currentStatus === "active") {
                      //     return ["Inactive", "Archive", "Discharged"].includes(status.label);
                      //   }

                      //   if (currentStatus === "inactive") {
                      //     return ["Active", "Archive", "Discharged"].includes(status.label);
                      //   }

                      //   if (currentStatus === "archived") {
                      //     return status.label === "Unarchive";
                      //   }
                      //   if (currentStatus === "discharged") {
                      //     return ["Active", "Inactive", "Archive"].includes(status.label);
                      //   }
                      //   return false;
                      // 
                      // }
                    )
                    .map((status) => (
                      <h5
                        key={status.value}
                        onClick={(e) => {
                          handleArchiveReport(e, item?.id, status.value)
                        }}
                        className="cursor-pointer proxima mb-2"
                      >
                        {status.label}
                      </h5>
                    ))
                  }
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>

      ),
    },
    {
      // head: "Action",
      accessor: "",
      isComponent: true,
      // sorter: true,
      component: (item, index) => (
        <div className="d-flex gap-3">
          <p onClick={(e) => {
            e.stopPropagation();
            if (item?.pdfList?.[0]?.attachment_key) {
              handleViewPdf(item.pdfList[0].attachment_key);
            }
          }} className="p-0" style={{ color: "#315D99", textDecoration: "underline", cursor: "pointer" }}>View Report</p>
          {item?.emailFormData &&
            <div
              onClick={(e) => {
                e.stopPropagation();
                toggleRow(item?.id);
              }}
            >
              {openRow == item.id ? (
                <img style={{ cursor: "pointer" }} width={12} src={downArrow} alt="Collapse" />
              ) : (
                <img style={{ cursor: "pointer" }} width={7} src={rightArrow} alt="Expand" />
              )
              }
            </div>
          }
        </div>
      ),
    },
  ];

  const toggleRow = (id) => setOpenRow(openRow === id ? null : id);

  useEffect(() => {
    if (classroomConsultationList?.records) setConsultationList(classroomConsultationList?.records || []);
  }, [classroomConsultationList]);


  return (
    <section className="designations position-relative py-4">
      <Container fluid>
        <Row>
          <Col lg="12" className="my-2">
            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
              <div className="left classroom-conslutation">
                <h6 className="m-0 fw-bold main-head themeBlue">Classroom Consultation</h6>
              </div>
              <div className="right">
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                  <li className="">
                    <Link to={'/manage-schools/school-profiles/add'} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                      Add a School
                    </Link>
                  </li>
                  <li className="">
                    <Link to={'/manage-teachers/add'} className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center">
                      Add a Teacher
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
          <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">School Division</label>
              <CommonSelect
                placeholder={"Choose one..."}
                option={schoolDivisonsList?.map((item) => ({ label: item?.title, value: item?.id }))}
                onChange={(e) => handleFilterChange("school_division")(e)}
                value={filter?.school_division}
                onInputChange={(val) => handleSearch(val)}
                isFilterV2
                isClearable
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%", // ✅ Ensures the whole Select container is full width
                  }),
                }}
                isLoading={schoolsLoading}
              />
            </div>
          </Col>
          <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">School</label>
              <CommonSelect
                placeholder={"Choose one..."}
                option={schoolOptions?.map((item) => ({ label: item?.name, value: item?.id }))}
                onChange={(e) => handleFilterChange("school")(e)}
                value={filter?.school}
                onInputChange={(val) => handleSearch(val)}
                isFilterV2
                isClearable
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
                isLoading={schoolsLoading}
              />
            </div>
          </Col>
          <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">Teacher</label>
              <CommonSelect
                placeholder={"Choose one..."}
                option={teachersList}
                onChange={(e) => handleFilterChange("teacher")(e)}
                value={filter?.teacher}
                onInputChange={(val) => handleSearch(val)}
                isFilterV2
                isClearable
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
                isLoading={schoolsLoading}
              />
            </div>
          </Col>
          <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">Grade</label>
              <CommonSelect
                placeholder={"Select Grade"}
                option={GRADE_OPTIONS?.map((item) => ({ label: item?.label, value: item?.value }))}
                onChange={(e) => handleFilterChange("grade")(e)}
                value={filter?.grade}
                isFilterV2
                isClearable
                // isLoading={schoolListLoading || schoolListFetching}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%", // ✅ Ensures the whole Select container is full width
                  }),
                }}
              />
            </div>
          </Col>
          <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">Status</label>
              <CommonSelect
                placeholder={"Select Status"}
                option={CLASSROOM_STATUS_OPTIONS}
                onChange={(e) => handleFilterChange("status")(e)}
                value={filter?.status}
                isFilterV2
                // isClearable
                // isLoading={schoolListLoading || schoolListFetching}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%", // ✅ Ensures the whole Select container is full width
                  }),
                }}
              />
            </div>
          </Col>
             <Col md='2'>
            <div className="w-100 align-items-center gap-3">
              <label className="discharge-screen-label mb-0">Discipline</label>
              <CommonSelect
                placeholder={"Select Discipline"}
                option={disciplinesList?.map((item) => ({ label: item?.name, value: item?.assign_term }))}
                onChange={(e) => handleFilterChange("assign_term")(e)}
                value={filter?.assign_term}
                isFilterV2
                isClearable
                // isLoading={schoolListLoading || schoolListFetching}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%", // ✅ Ensures the whole Select container is full width
                  }),
                }}
              />
            </div>
          </Col>
          <div className="table-outer classroom-consultation">
            {classroomConsultationListLoading ? (
              <div style={{ height: "200px" }}>
                <LoadingIndicator />
              </div>
            ) : classroomConsultationListError ? (
              <ErrorComponent />
            ) : consultationList?.length ? (
              <>
                {/* {(classroomConsultationListFetching || deleteConsultationLoading || favouriteReportLoading || copyReportLoading || deleteReportLoading || startNewReportLoading) && <LoadingOverlay />} */}
                {(favouriteReportLoading || getFileFetching || classroomConsultationListLoading || classroomConsultationListFetching || archiveReportLoading) && <LoadingOverlay />}
                <TableLayoutV2
                  viewPdf={false}
                  tdStyle="#f5f5f5"
                  data={consultationList || []}
                  column={columns}
                  filter={filter}
                  // url={EDIT_SCHOOL_CLASSROOM_PLAN.replace("/:reportId", "")}
                  handleSort={handleFilterChange("sort")}
                  expandableRowComponent={(row) => {
                    let emailData = {} || [];
                    try {
                      const parsed = JSON.parse(row?.emailFormData || '[]');

                      emailData = Array.isArray(parsed)
                        ? parsed
                        : parsed?.emails
                          ? parsed.emails
                          : [];

                    } catch (error) {
                      console.error('Invalid JSON in emailFormData', error);
                    }
                    const date = moment(row?.publishedAt).format("MMM DD, YYYY");
                    const time = moment(row?.publishedAt).format("h:mm A");
                    return (
                      <div style={{ borderTop: "0.25px solid #00000036", paddingTop: "8px" }} className="d-flex gap-3">
                        <div className="text-end d-flex text-gray-500" style={{ width: "20%", gap: "30px", paddingTop: "6px" }}>
                          <p>{time}</p>
                        </div>
                        <table style={{ width: "50%", borderCollapse: "separate", borderSpacing: "0 6px" }}>
                          <tbody>
                            <tr className="border-0">
                              <th className="border-0 p-0 text-left">Published to:</th>
                              <td className="border-0 p-0 text-left" style={{ textIndent: "13px" }}>Teacher Dashboard</td>
                            </tr>
                            <tr className="border-0">
                              <th className="border-0 p-0 text-left" style={{ verticalAlign: "baseline" }}><p className="px-0">Email to:</p></th>
                              <td className="border-0 p-0">
                                <div>
                                  {
                                    emailData?.map(item => (
                                      <div className="d-flex">
                                        <p className="mb-0">{item?.email}</p>
                                        <p>{item?.firstname} {item?.lastname}</p>
                                      </div>
                                    ))
                                  }
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )
                  }}
                  toggleRow={toggleRow}
                  openRow={openRow}
                />
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  className="paginationV2"
                  handlePageChange={handlePageChange}
                />
              </>
            ) : (
              <div className="classroom-no-reports mt-5">
                <p>Looks like you don't have any classroom consultations in progress yet. Your list of these reports will appear here.</p>
              </div>
            )}
          </div>
        </Row>
      </Container>
    </section>
  )
}

export default ClassroomConsultations


// const TableLayout = ({ openRow, toggleRow, expandableRowComponent, column, data, url, showHeader = true, noDataMsg = "Data not found", state, filter, handleRowClick, height, handleSort }) => {
//   const navigate = useNavigate();
//   const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

//   // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

//   const handleSortClick = (item) => {

//     let sort = {};
//     console.log('filter sort and item?.accessor', filter, item?.accessor)
//     if (filter?.sort?.column == item?.accessor) {

//       if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
//       else sort = { column: "id", direction: "desc" };

//     } else sort = { column: item?.accessor, direction: "asc" }

//     typeof handleSort === "function" && handleSort(sort);
//   };

//   const handleViewPdf = async (name) => {

//     try {
//       const result = await getFileUrl(name);
//       if (result?.error) return;

//       const url = result?.data
//       if (url) window.open(url, '_blank');

//     } catch (err) { console.error("Error assigning therapist", err); }
//   };



//   return (
//     <div className="favorite-goal-wrapper classroom-consultation proxima table_height" style={{ height: height || "calc(100vh - 220px)" }}>
//       {
//         getFileFetching && <LoadingOverlay />
//       }
//       <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
//         <table className={`${styles.table} table`}>
//           {showHeader && (
//             <thead>
//               <tr className="">
//                 {column &&
//                   column.length > 0 &&
//                   column.map((item, key) => (
//                     <>
//                       <th className="text-dark border-0" style={{ fontWeight: 500 }}>
//                         <div className="d-flex">
//                           {item.head}
//                           {
//                             item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
//                               {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "asc" ? <ArrowUpFilled /> : <ArrowUpOutline />}
//                               {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "desc" ? <ArrowDownFilled /> : <ArrowDownOutline />}
//                             </div>
//                           }
//                         </div>
//                       </th>
//                     </>
//                   ))}
//               </tr>
//             </thead>
//           )}
//           <tbody>
//             {data && data.length > 0 ? (
//               data.map((row, idx) => (
//                 <React.Fragment key={row.id || idx}>
//                   {/* Main Row */}
//                   <tr
//                     className={`${url ? "cursor-pointer" : ""}`}
//                     onClick={(e) => {
//                       if (row?.pdfList?.[0]?.attachment_key)
//                         handleViewPdf(row?.pdfList?.[0]?.attachment_key);
//                       else {
//                         url && navigate(`${url}/${row.id}`, { state });
//                         handleRowClick?.(row);
//                       }
//                     }}
//                   >
//                     {column?.map((item, key) => (
//                       <td
//                         key={key}
//                         className={`${row?.status === "copied"
//                           ? "copied-report-bcg"
//                           : row?.status === "complete" && "published-report-bcg"
//                           } ${openRow == row?.id && 'border-bottom-0 rounded-bottom-0'} `}
//                       >
//                         {item.component
//                           ? item.component(row, idx, row)
//                           : row[item?.accessor] || "--"}
//                       </td>
//                     ))}
//                   </tr>

//                   {/* Expanded Row */}
//                   {expandableRowComponent && openRow === row.id && (
//                     <tr style={{ position: 'relative', top: "-10px" }}>
//                       <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={2}></td>
//                       <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={7}>
//                         {expandableRowComponent(row)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={column?.length || 1} className="text-center">
//                   {noDataMsg}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };





const ArrowUpFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up-fill"
      viewBox="0 0 16 16"
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
    </svg>
  )
};

const ArrowDownFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  )
}

const ArrowDownOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
    </svg>
  )
}

const ArrowUpOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
    </svg>
  )
}